import {
  CalendarDays,
  UsersRound,
  ShoppingCart,
  ChartNoAxesCombined,
  Settings,
  Headset,
  Sparkles,
  ClipboardCheck,
  PanelLeft,
} from "lucide-react";

import { motion } from "framer-motion";
import { Link } from "./link";
import { useMenu } from "../../store/global/useMenu";
import { Syringe } from "@phosphor-icons/react/dist/ssr";
import { useMerchant } from "../../store/global/useMerchant";

export function Menu() {
  const menuActions = useMenu.getState().actions
  const menuSize = useMenu(st => st.data.size)
  const menuOpen = useMenu(st => st.data.open)
  const merchant = useMerchant(st => st.data.merchant)

  return (
    <motion.div
      initial={{ width: menuSize }}
      animate={{ width: menuSize }}
      transition={{ duration: 0.3 }}
      className="h-full flex border-r border-zinc-200/40 shadow-md z-10  bg-white relative"
    >
      <div className="absolute left-0 top-0 bg-white w-full h-2 -translate-y-1/2" />
      <div className="relative flex flex-col w-full h-full items-start justify-start gap-y-1">
        <button onClick={() => menuActions.toggleSize()} className="flex w-full items-center justify-end  px-6 py-3 gap-2 text-white bg-scale-400 font-bold transition duration-700 hover:text-zinc-500 hover:bg-transparent hover:duration-200">
          {menuOpen && <span>Fechar</span>}
          <PanelLeft className="min-w-6 min-h-6" />
        </button>
        <Link.item name="agenda" to="/agenda" >
          <CalendarDays className="min-w-6 min-h-6" />
          <Link.text>Agenda</Link.text>
        </Link.item>
        <Link.item name="agenda-inteligente" to="/agenda-inteligente" >
          <Sparkles className="min-w-6 min-h-6" />
          <Link.text>Agendamentos</Link.text>
        </Link.item>
        <Link.item name="clientes" to="/clientes" >
          <UsersRound className="min-w-6 min-h-6" /><Link.text>Clientes</Link.text>
        </Link.item>
        <Link.item
          name="vendas"
          to={[
            { to: "/assinaturas", label: "Assinatura", hidden: 'veterinary' },
            { to: "/pacotes", label: "Pacotes" },
            { to: "/vendas/crm-pet", label: "CRM Pet", hidden: "veterinary" }
          ]}
        >
          <ShoppingCart className="min-w-6 min-h-6" /><Link.text>Vendas</Link.text>
        </Link.item>
        <Link.item
          name="vacinas"
          hidden={'petShop'}
          to={[
            { to: "/protocolos", label: "Protocolos" },
            { to: "/clinica/relatorios/vacinacoes", label: "Vacinas Programadas" },
          ]}
        >
          <Syringe className="min-w-6 min-h-6" /><Link.text>Vacinas</Link.text>
        </Link.item>
        <Link.item name="relatorios" to={[
          { to: "/relatorio", label: "Relatórios" },
          { to: "/avaliacoes", label: "Avaliações" },
          { to: "/diagnosis/crm-pet", label: "Diagnóstico CRM Pet" }
        ]}>
          <ChartNoAxesCombined className="min-w-6 min-h-6" /><Link.text>Relatórios</Link.text>
        </Link.item>
        <Link.item name="configuracoes" to={[
          { to: "/servicos", label: "Serviços" },
          { to: "/profissionais", label: "Profissionais" },
          { to: "/cupom", label: "Cupons", hidden: 'veterinary' },
          { to: "/configuracoes", label: "Informações de Loja" },
        ]}>
          <Settings className="min-w-6 min-h-6" /><Link.text>Configurações</Link.text>
        </Link.item>
        <Link.item name="suporte" to="/suporte" >
          <Headset className="min-w-6 min-h-6" /><Link.text>Suporte</Link.text>
        </Link.item>
      </div>
    </motion.div>
  );
}
